import styles from "./ImagesWrapper.module.scss";

import image1 from "../../../assets/images/imagesWrapper/1.png";
import image2 from "../../../assets/images/imagesWrapper/2.png";
import image3 from "../../../assets/images/imagesWrapper/3.png";

const ImagesWrapper = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div>
          <img className={styles.image1} src={image1} alt={"1"} />
        </div>
        <div>
          <img className={styles.image2} src={image2} alt={"2"} />
        </div>
        <div>
          <img className={styles.image3} src={image3} alt={"3"} />
        </div>
      </div>
    </div>
  );
};

export default ImagesWrapper;
